<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <template v-if="sectionType === 'table'">
          <set-test-table
            @change-section="sectionHandler"
            @delete="deleteSetTestHandler"
            @change-edit="sectionHandler('edit', $event)"
            @change-price="sectionHandler('price', $event)"
          />
        </template>
        <template v-if="sectionType === 'detail'">
          <set-test-detail
            v-model="setTestSelected"
            @submit="updateSetTestHandler"
            @back="sectionHandler('table')"
          />
        </template>
        <template v-if="sectionType === 'price'">
          <price-group
            v-model="priceGroups"
            nav-btn
            @submit="updatePriceGroupHandler"
            @back="sectionHandler('table')"
          />
        </template>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import SetTestTable from "../../components/Settings/SetTestView/SetTestTable";
  import SetTestDetail from "../../components/Settings/SetTestView/SetTestDetail";
  import PriceGroup from "../../components/Settings/PriceGroup";
  import { mapActions } from 'vuex'

  export default {
    name: "SetTestView",
    components: {PriceGroup, SetTestDetail, SetTestTable},
    data() {
      return {
        sectionType: 'table',
        setTestSelected: {
          id: null,
          name: null,
          tests: []
        },
        priceGroups: []
      }
    },
    methods: {
      ...mapActions({
        getSetTest: 'Test/getSetTestById',
        updateSetTest: 'Settings/updateSetTest',
        setSetTest: 'Test/setSetTest',
        deleteSetTest: 'Test/deleteSetTest',
        getPriceGroup: 'Settings/getPriceGroupBySetTestId',
        updateSetTestPriceGroup: 'Settings/updateSetTestPriceGroup',
      }),
      async sectionHandler(type, value=null) {
        this.$store.state.isLoading = true
        if (type === 'create') {
          this.setTestSelected = {
            id: null,
            name: null,
            tests: []
          }
          this.priceGroups = []
          this.sectionType = 'detail'
        }
        else if (type === 'edit') {
          let setTestResponse
          try {
            setTestResponse = await this.getSetTest(value)
          } catch (e) {
            await this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
            this.$store.state.isLoading = false
            return
          }
          this.setTestSelected = {
            id: setTestResponse.id,
            name: setTestResponse.name,
            tests: setTestResponse.set_test_detail.map(detail => detail.test_id)
          }
          this.priceGroups = []
          this.sectionType = 'detail'

        }
        else if (type === 'price') {
          let setTestResponse
          try {
            setTestResponse = await this.getSetTest(value)
          } catch (e) {
            await this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
            this.$store.state.isLoading = false
            return
          }
          this.setTestSelected = {
            id: setTestResponse.id,
            name: setTestResponse.name,
            tests: setTestResponse.set_test_detail.map(detail => detail.test_id)
          }
          
          let priceGroupsResponse
          try {
            priceGroupsResponse = await this.getPriceGroup(this.setTestSelected.id)
          } catch (e) {
            await this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
            this.$store.state.isLoading = false
            return
          }
          
          this.priceGroups = priceGroupsResponse.map(priceGroup => ({
            detail: priceGroup.detail,
            set_test_id: this.setTestSelected.id,
            price_group_id: priceGroup.id,
            price: priceGroup.price ? priceGroup.price.price : 0
          }))
          
          this.sectionType = 'price'
        }
        else if (type === 'table') {
          this.setTestSelected = {
            id: null,
            name: null,
            tests: []
          }
          this.priceGroups = []
          this.sectionType = 'table'
        }
        this.$store.state.isLoading = false
      },
      async deleteSetTestHandler(data) {
        this.$store.state.isLoading = true
        try {
          await this.deleteSetTest(data)
        } catch (e) {
          await this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
          this.$store.state.isLoading = false
          return
        }

        try {
          await this.setSetTest()
        } catch (e) {
          await this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
          this.$store.state.isLoading = false
          return
        }
        this.setTestSelected = {
          id: null,
          name: null,
          tests: []
        }
        this.sectionType = 'table'
        await this.$swal.fire('สำเร็จ', 'บันทึกชุดตรวจเสร็จสิ้น', 'success')
        this.$store.state.isLoading = false
      },
      async updateSetTestHandler(password) {
        this.$store.state.isLoading = true
        try {
          await this.updateSetTest({ ...this.setTestSelected, password })
        } catch (e) {
          await this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
          this.$store.state.isLoading = false
          return
        }

        try {
          await this.setSetTest()
        } catch (e) {
          await this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
          this.$store.state.isLoading = false
          return
        }
        this.setTestSelected = {
          id: null,
          name: null,
          tests: []
        }
        this.sectionType = 'table'
        await this.$swal.fire('สำเร็จ', 'บันทึกชุดตรวจเสร็จสิ้น', 'success')
        this.$store.state.isLoading = false
      },
      async updatePriceGroupHandler(password) {
        this.$store.state.isLoading = true

        try {
          await this.updateSetTestPriceGroup({ payload: this.priceGroups, password})
        } catch (e) {
          await this.$swal.fire('เกิดข้อผิดพลาด', e.message, 'error')
          this.$store.state.isLoading = false
          return
        }
        this.setTestSelected = {
          id: null,
          name: null,
          tests: []
        }
        this.priceGroups = []

        this.sectionType = 'table'
        await this.$swal.fire('สำเร็จ', 'บันทึกชุดตรวจเสร็จสิ้น', 'success')
        this.$store.state.isLoading = false

      }
    }
  }
</script>

<style scoped>

</style>